import React, { useState } from "react";
import styled from "styled-components";

const CheckBoxComponent = ({
  label,
  helperText,
  checked,
  onChange,
  disabled = false,
  ...props
}) => {
  return (
    <CheckBoxWrapper>
      <Label disabled={disabled}>
        <Input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <CustomCheckbox checked={checked} disabled={disabled}>
          {checked && (
            <CheckIcon>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.6667 3.5L5.25 9.91667L2.33333 7"
                  stroke="#ffffff "
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </CheckIcon>
          )}
        </CustomCheckbox>
        {label}
      </Label>
      {helperText && <HelperText>{helperText}</HelperText>}
    </CheckBoxWrapper>
  );
};

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  display: flex;
  align-items: start;
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  gap: 8px;
  text-align: left;
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const CustomCheckbox = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid #00000033;
  border-radius: 6px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;

  ${({ disabled }) =>
    disabled &&
    `
      background: rgb(241, 245, 249);
      border-color: rgb(224, 228, 244);
      cursor: not-allowed;
    `}

  ${Input}:checked + & {
    background: rgb(97, 98, 197);
    border-color: rgb(97, 98, 197);
  }

  ${Input}:focus + & {
    box-shadow: 0 0 0 2px rgba(97, 98, 197, 0.2);
  }

  &:hover {
    border-color: rgb(97, 98, 197);
  }
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: white;
`;

const HelperText = styled.span`
  font-size: 12px;
  color: rgb(143, 143, 143);
`;
export default CheckBoxComponent;
